module.exports = __webpack_public_path__ + "static/media/redditClone.11a8e1d3.png";